/* Kintra header behaviour:
   - scroll state (transparent → navy in overlay mode, shadow in solid mode)
   - desktop dropdowns: CSS handles hover; the caret button toggles for
     keyboard & touch; outside click / Escape closes
   - mobile drawer toggle with scroll lock; chevron buttons expand submenus */

(function () {
  var header = document.querySelector('[data-kintra-header]');
  if (!header) return;

  /* ----- scroll state ----- */
  var threshold = 24;
  var ticking = false;

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      header.classList.toggle('is-scrolled', window.scrollY > threshold);
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ----- desktop dropdown caret buttons (keyboard & touch) ----- */
  var panelItems = Array.prototype.slice.call(
    header.querySelectorAll('[data-kh-panel-item]')
  );

  function closePanels(except) {
    panelItems.forEach(function (item) {
      if (item === except) return;
      item.classList.remove('is-open');
      var btn = item.querySelector('[data-kh-panel-toggle]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  panelItems.forEach(function (item) {
    var btn = item.querySelector('[data-kh-panel-toggle]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) closePanels(item);
    });
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-kh-panel-item]')) closePanels(null);
  });

  /* ----- mobile drawer ----- */
  var burger = header.querySelector('[data-kh-burger]');
  var drawer = header.querySelector('[data-kh-drawer]');

  var drawerSettleTimer;
  /* visible, focusable elements inside the drawer (collapsed submenu links are
     excluded until their section is expanded) */
  function drawerFocusables() {
    return Array.prototype.slice.call(
      drawer.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
    ).filter(function (el) { return el.offsetParent !== null; });
  }
  function openDrawer() {
    clearTimeout(drawerSettleTimer);
    drawer.classList.add('is-open');
    header.classList.add('kh-drawer-active');
    document.body.classList.add('kh-drawer-open');
    burger.setAttribute('aria-expanded', 'true');
    burger.setAttribute('aria-label', 'Close menu');
    /* move focus into the drawer once it's visible, so keyboard / screen-reader
       users land inside the menu (focus is then trapped there until it closes).
       Wait for the slide-in to settle — a bare rAF can land mid-transition while
       the target isn't yet focusable. */
    setTimeout(function () {
      if (!drawer.classList.contains('is-open')) return;
      var f = drawerFocusables();
      if (f.length) f[0].focus();
    }, 80);
  }
  function closeDrawer(returnFocus) {
    drawer.classList.remove('is-open');
    document.body.classList.remove('kh-drawer-open');
    burger.setAttribute('aria-expanded', 'false');
    burger.setAttribute('aria-label', 'Open menu');
    /* keep the navy bar until the drawer has fully slid out —
       removing it instantly flashes the bar transparent mid-animation */
    clearTimeout(drawerSettleTimer);
    drawerSettleTimer = setTimeout(function () {
      header.classList.remove('kh-drawer-active');
    }, 320);
    /* hand focus back to the burger so keyboard users aren't stranded */
    if (returnFocus && burger) burger.focus();
  }

  if (burger && drawer) {
    burger.addEventListener('click', function () {
      drawer.classList.contains('is-open') ? closeDrawer(true) : openDrawer();
    });
    drawer.addEventListener('click', function (event) {
      if (event.target.closest('a')) closeDrawer(false); /* navigating away */
    });
    /* guard addEventListener — older Safari's MediaQueryList only has addListener,
       and an unguarded call here would throw and abort the submenu wiring below */
    var deskMq = window.matchMedia('(min-width: 990px)');
    if (deskMq.addEventListener) {
      deskMq.addEventListener('change', function (e) { if (e.matches) closeDrawer(false); });
    } else if (deskMq.addListener) {
      deskMq.addListener(function (e) { if (e.matches) closeDrawer(false); });
    }

    /* focus trap: keep Tab / Shift+Tab cycling inside the open drawer instead of
       walking onto the page hidden behind it */
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab' || !drawer.classList.contains('is-open')) return;
      var f = drawerFocusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first.focus();
      } else if (!drawer.contains(document.activeElement)) {
        event.preventDefault(); first.focus();
      }
    });

    /* drawer submenu chevrons */
    drawer.querySelectorAll('[data-kh-sub-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sub = btn.closest('li').querySelector('.kintra-header__drawer-sub');
        if (!sub) return;
        var open = sub.hidden;
        sub.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    closePanels(null);
    if (drawer && drawer.classList.contains('is-open')) closeDrawer(true);
  });
})();
